import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { routeConfig } from '../../shared/common/constant';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import {
    AddBusinessPartnerBankDetails, AddCompanyBankDetailsQuery,
    UpdateCompanyBankDetails, UpdateBusinessPartnerBankDetails
} from '../../shared/common/graphqlQuery';
import { companyData } from '../../core/auth';
import { useStore } from '../../shared/hooks/stateStore';
import { Button, Form, Input } from 'antd';
import { validateLabelMessages } from '../../shared/hooks/utils';
import { LoadingOutlined } from '@ant-design/icons';

const onError = (error: any) => {
    console.log(error, 'mymy');
}

let companyBankData;
const AddEditBank = () => {
    const companyId = companyData().getCompanyData();
    const { businessPartnerId, companyBankId, businessPartnerBankId } = useParams<any>();
    const history = useHistory();
    const redirectBack = (url) => {
        history.push(url);
    }
    if (companyBankId) {
        companyBankData = useStore.getState().companyBank;
        if (!companyBankData) {
            history.push(routeConfig.companyAllBanksList.path);
        }
    } else {
        if (businessPartnerId && businessPartnerBankId) {
            companyBankData = useStore.getState().companyBank;
            if (!companyBankData) {
                history.push(routeConfig.consigneeList.path);
            }
        } else {
            companyBankData = null
        }
    }
    const onSubmitted = (result: any) => {
        redirectBack(businessPartnerId ? routeConfig.consigneeList.path : routeConfig.companyAllBanksList.path);
    }
    const redirectCondition = () => {
        redirectBack(businessPartnerId ? routeConfig.consigneeList.path : routeConfig.companyAllBanksList.path);
    }
    const { callMutation, loading } = useMutationHook(AddBusinessPartnerBankDetails, onSubmitted, onError);
    const businessPartnerUpdateBankMutation = useMutationHook(UpdateBusinessPartnerBankDetails, onSubmitted, onError);
    const CompanyBankDetailMutation = useMutationHook(AddCompanyBankDetailsQuery, onSubmitted, onError);
    const CompanyBankUpdateMutation = useMutationHook(UpdateCompanyBankDetails, onSubmitted, onError);
    const onFinish = (values: any) => {
        if (!loading && !CompanyBankUpdateMutation.loading && !CompanyBankDetailMutation.loading && !businessPartnerUpdateBankMutation.loading) {
            if (businessPartnerId) {
                if (businessPartnerBankId) {
                    businessPartnerUpdateBankMutation.callMutation({ variables: { updateBusinessPartnerBankInput: { bankDetail: values, businessPartnerBankId, companyId } } })
                } else {
                    callMutation({ variables: { bankInput: { ...values, businessPartnerId: businessPartnerId, companyId } } });
                }
            } else if (companyBankId) {
                CompanyBankUpdateMutation.callMutation({ variables: { updateCompanyBankInput: { bankDetail: values, companyId, companyBankId } } });
            } else {
                CompanyBankDetailMutation.callMutation({ variables: { bankInput: { ...values, companyId } } });
            }
        }
    };

    return (
        <div className="form-wrapper">
            <Form
                name="basic"
                layout="vertical"
                onFinish={onFinish}
                // validateTrigger='onSubmit'
                validateMessages={validateLabelMessages}
                scrollToFirstError={true}
                initialValues={companyBankData}
            >
                <Form.Item
                    label="Bank Name"
                    name='bankName'
                    rules={[{ required: true, whitespace: true }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Bank Address"
                    name='address'
                    rules={[{ required: true, whitespace: true }]}
                >
                    <Input.TextArea />
                </Form.Item>
                <Form.Item
                    label="SWIFT Code"
                    name='swiftCode'
                    rules={[{ required: true, whitespace: true },
                    {
                        pattern: /[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?/,
                        // pattern: /[0-9a-f]{1}/,
                        message: 'Please enter valid Swift Code'
                    }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Account Number"
                    name='acNumber'
                    rules={[{ required: true, whitespace: true }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    label="Account Name"
                    name='accountName'
                    rules={[{ required: true, whitespace: true }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" ghost htmlType="submit" className="btn" onKeyDown={onFinish} style={{ width: 75 }}>
                        {(loading || CompanyBankUpdateMutation.loading || CompanyBankDetailMutation.loading || businessPartnerUpdateBankMutation.loading) ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>
                    <Button danger type="ghost" onClick={redirectCondition} >
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
export default AddEditBank